import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "header-wr" }
const _hoisted_2 = { class: "header-mobile" }
const _hoisted_3 = { class: "top-row" }
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = { class: "header-desktop" }
const _hoisted_6 = { class: "header-controls" }
const _hoisted_7 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "logo",
          to: "/"
        }),
        _createElementVNode("div", _hoisted_4, [
          ($setup.showLogin)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "link-primary",
                onClick: $setup.onLogin
              }, "Log in"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("header", _hoisted_5, [
      _createVNode(_component_router_link, {
        class: "logo",
        to: "/"
      }),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          ($setup.showLogin)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "link-primary",
                onClick: $setup.onLogin
              }, "Log in"))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}